import { useMemo } from 'react'
import moment from 'moment'

const GHOST_MESO_VOLUME_ID = 'GHOST_MESO_VOLUME'

export default function MacroVolumeFocusTimelineDisplay({
    renderRangeStart,
    renderRangeEnd,
    daySpacing = 0,
    macroVolumeFocusTypeHashMap = {},
    macroVolumeFocuses = [],
    mesoVolumes = [],
    DateToTrackLeftX = () => { return 0 }
}) {

    const macroVolumeFocusDisplayData = useMemo(() => {
        if (daySpacing <= 0) {
            return []
        }

        const newMarcoVolumeDisplayData = []

        macroVolumeFocuses.forEach((macroVolumeFocus) => {
            const startDate = moment(macroVolumeFocus.startDate).startOf('day')
            const endDate = moment(macroVolumeFocus.endDate).startOf('day')

            if (
                !startDate.isValid()
                || !endDate.isValid()
                || endDate.isBefore(renderRangeStart, 'day')
                || startDate.isAfter(renderRangeEnd, 'day')
            ) {
                return
            }

            const left = DateToTrackLeftX(startDate)
            const width = DateToTrackLeftX(endDate.clone().add(1, 'day')) - left

            newMarcoVolumeDisplayData.push({
                left,
                width,
                isGhostWeek: false,
                macroVolumeFocusTypeId: macroVolumeFocus.macroVolumeFocusTypeId,
            })
        })

        // Ghost spacer weeks live on mesoVolumes only — paint matching gray bars here.

        mesoVolumes.forEach((mesoVolume) => {
            if (mesoVolume.mesoVolumeId !== GHOST_MESO_VOLUME_ID) {
                return
            }

            const startDate = moment(mesoVolume.startDate).startOf('day')
            const endDate = moment(mesoVolume.endDate).startOf('day')

            if (
                !startDate.isValid()
                || !endDate.isValid()
                || endDate.isBefore(renderRangeStart, 'day')
                || startDate.isAfter(renderRangeEnd, 'day')
            ) {
                return
            }

            const left = DateToTrackLeftX(startDate)
            const width = DateToTrackLeftX(endDate.clone().add(1, 'day')) - left

            newMarcoVolumeDisplayData.push({
                left,
                width,
                isGhostWeek: true,
                macroVolumeFocusTypeId: null,
            })
        })

        return newMarcoVolumeDisplayData
    }, [
        renderRangeStart,
        renderRangeEnd,
        daySpacing,
        macroVolumeFocuses,
        mesoVolumes,
        DateToTrackLeftX,
    ])

    if (
        Object.keys(macroVolumeFocusTypeHashMap).length === 0 
        && !macroVolumeFocusDisplayData.some((item) => item.isGhostWeek)
    ) {
        return <div className='relative h-4 2xl:h-5' />
    }

    return (
        <div className='relative h-4 2xl:h-5'>
            {macroVolumeFocusDisplayData.map((macroVolumeFocusDisplay, index) => (
                <div
                    key={index}
                    className='absolute bottom-0 h-4 2xl:h-5 px-[1.5px] 2xl:px-[2px] transition-opacity'
                    style={{
                        left: `${macroVolumeFocusDisplay.left}px`,
                        width: `${macroVolumeFocusDisplay.width}px`,
                    }}
                >
                    <div
                        className={`
                            h-full flex items-center justify-center overflow-hidden rounded 
                            ${macroVolumeFocusDisplay.isGhostWeek ? 'bg-gray-300' : ''}
                        `}
                        style={
                            macroVolumeFocusDisplay.isGhostWeek ? undefined : {
                                backgroundColor: macroVolumeFocusTypeHashMap[macroVolumeFocusDisplay.macroVolumeFocusTypeId]?.colorHex,
                            }
                        }
                    >
                        {!macroVolumeFocusDisplay.isGhostWeek && (
                            <span
                                className='text-xxs 2xl:text-xs font-medium whitespace-nowrap px-1'
                                title={macroVolumeFocusTypeHashMap[macroVolumeFocusDisplay.macroVolumeFocusTypeId]?.name}
                            >
                                {macroVolumeFocusTypeHashMap[macroVolumeFocusDisplay.macroVolumeFocusTypeId]?.name}
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    )
}
